<template>
  <div
    class="content work_flow_wrap"
    v-loading.fullscreen.lock="fullscreenLoading"
  >
    <div class="tab-wrap">
      <el-tabs v-model="page.listType" @tab-click="filterFlow">
        <el-tab-pane label="全部流程" name="0"></el-tab-pane>
        <el-tab-pane label="待处理" name="4"></el-tab-pane>
        <el-tab-pane label="已处理" name="2"></el-tab-pane>
        <el-tab-pane label="我收到的" name="3"></el-tab-pane>
        <el-tab-pane label="我发起的" name="1"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">应用公司：</div>
          <el-select
            size="mini"
            filterable
            clearable
            v-model="page.tenantGuid"
            class="ipt-sty"
            placeholder="请选择"
            @change="handleChangeCompany"
          >
            <el-option
              v-for="item in sendTenantList"
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">应用部门：</div>
          <el-select
            size="mini"
            filterable
            clearable
            v-model="page.organisationGuid"
            class="ipt-sty"
            placeholder="请选择"
          >
            <el-option
              v-for="item in organisationList"
              :key="item.guid"
              :label="item.organisationName"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">问卷标题：</div>
          <el-input
            size="mini"
            v-model="page.surveyTitle"
            class="ipt-sty"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? "收起筛选" : "更多筛选" }}
          </el-button>
          <el-button size="mini" type="info" @click="getList(1)"
            >搜索</el-button
          >
          <el-button size="mini" type="danger" @click="emptySearch"
            >清空</el-button
          >
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">问卷来源：</div>
          <el-select
            size="mini"
            filterable
            clearable
            v-model="page.isShowPlatformTemplate"
            class="ipt-sty"
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionPlat"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">审批状态：</div>
          <el-select
            size="mini"
            filterable
            clearable
            v-model="page.approveState"
            class="ipt-sty"
            placeholder="请选择"
          >
            <el-option
              v-for="item in ApproveStateOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">提交人：</div>
          <el-input
            size="mini"
            v-model="page.staffName"
            clearable
            class="ipt-sty"
            placeholder="请输入"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">提交时间：</div>
          <el-date-picker
            size="mini"
            v-model="page.submitTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-col>
        <el-col :span="6" class="mt15">
          <div class="search-area-div">流程名称：</div>
          <el-select
            size="mini"
            filterable
            clearable
            v-model="page.flowTypeList"
            multiple
            class="ipt-sty"
            placeholder="请选择"
          >
            <el-option
              v-for="item in processNameList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="mt15">
          <div class="search-area-div">流程编号：</div>
          <el-input
            size="mini"
            v-model="page.flowNo"
            clearable
            class="ipt-sty"
            placeholder="请输入"
          ></el-input>
        </el-col>
      </el-row>
    </div>
    <div
      class="back-color-fff content-main-box"
      :style="'height:' + contentMainHeight + 'px'"
    >
      <el-table
        :data="tableData"
        stripe
        border
        style="width: 100%"
        v-loading="tableLoading"
        :height="tableHeight"
      >
        <el-table-column
          label="序号"
          width="60"
          header-align="center"
          align="center"
          fixed="left"
        >
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="tenantName"
          label="应用公司"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="180"
          fixed="left"
        >
          <template slot-scope="scope">{{
            scope.row.tenantName || "-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="organisationName"
          label="应用部门"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="150"
        >
          <template slot-scope="scope">{{
            scope.row.organisationName
              ? scope.row.organisationName.join()
              : "-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="surveyTitle"
          label="问卷标题"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="180"
        >
          <template slot-scope="scope">{{
            scope.row.surveyTitle || "-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="isShowPlatformTemplate"
          label="问卷来源"
          show-overflow-tooltip
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.isPlatformTemplate == "Y" ? "平台" : "药企" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="surveyExecuteRules"
          width="330"
          label="规则说明"
          header-align="left"
          align="left"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.surveyExecuteRules?.length > 0">
              <span v-if="scope.row.surveyExecuteRules.length == 1">
                <el-tooltip
                  v-if="scope.row.surveyExecuteRules[0].ruleDesc.length > 19"
                  :content="scope.row.surveyExecuteRules[0].ruleDesc"
                  placement="top-start"
                  effect="light"
                >
                  <span class="showTooltip">{{
                    scope.row.surveyExecuteRules[0].ruleDesc
                  }}</span>
                </el-tooltip>
                <span v-else>{{
                  scope.row.surveyExecuteRules[0].ruleDesc
                }}</span>
              </span>
              <span v-else>
                <el-tooltip placement="top-start" effect="light">
                  <div slot="content">
                    <div
                      v-for="(rule, d) in getRuleList(
                        scope.row.surveyExecuteRules
                      )"
                    >
                      <p>{{ d + 1 }}.{{ rule.ruleDesc }}</p>
                    </div>
                  </div>
                  <span class="showTooltip"
                    >{{ scope.row.surveyExecuteRules[0].ruleDesc }}({{
                      scope.row.surveyExecuteRules.length
                    }})</span
                  >
                </el-tooltip>
              </span>
            </template>
            <template v-if="!scope.row.surveyExecuteRules">
              <span>-</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop="flowName"
          label="流程名称"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.approveVO?.flowName || "-" }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="approveState"
          label="审批状态"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <span :class="getStateShow(scope.row.approveVO?.approveState)">
              {{ scope.row.approveVO?.approveState | approveState }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="staffName"
          label="提交人"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.approveVO?.staffName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="提交时间"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="140"
        >
          <template slot-scope="scope">
            {{ scope.row.approveVO?.createTime | getTime }}
          </template>
        </el-table-column>
        <el-table-column
          prop="publishState"
          label="发布状态"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="140"
        >
          <template slot-scope="scope">
            {{ scope.row.publishState == "Y" ? "已发布" : "未发布" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="flowNo"
          label="流程编号"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="140"
        >
          <template slot-scope="scope">
            {{ scope.row.approveVO?.flowNo || "-" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="approveTime"
          label="操作时间"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="140"
        >
          <template slot-scope="scope">
            {{ scope.row.updateTime | getTime }}
          </template>
        </el-table-column>
        <el-table-column
          prop="bank"
          width="260"
          label="操作"
          fixed="right"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <a
              class="txt-color"
              @click="passDialogClick(scope.row)"
              v-if="getListBtnState('approval', scope.row) == 'approval'"
            >
              通过
            </a>
            <a
              class="txt-color"
              @click="rejectDialogClick(scope.row)"
              v-if="getListBtnState('approval', scope.row) == 'approval'"
            >
              驳回
            </a>
            <a
              class="txt-color"
              @click="toRevoke(scope.row)"
              v-if="getListBtnState('revoke', scope.row) == 'revoke'"
            >
              撤销
            </a>
            <a
              class="txt-color"
              @click="toEdit(scope.row)"
              v-if="getListBtnState('edit', scope.row) == 'edit'"
            >
              编辑
            </a>
            <a
              class="txt-color"
              @click="toResubmit(scope.row)"
              v-if="getListBtnState('again', scope.row) == 'again'"
            >
              重新提交
            </a>
            <!-- <a 
              class="txt-color" 
              v-if="getListBtnState('again', scope.row) == 'again'"
              @click="editVersion(scope.row, 1)"
            >
              重新提交 ｜
            </a> -->
            <a
              class="txt-color"
              v-if="getListBtnState('detail', scope.row) == 'detail'"
              @click="toDetail(scope.row)"
            >
              详情
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <RejectQuestionnaireReviewDialog
      ref="RejectQuestionnaireReviewDialogRef"
      @submit="handleRejectSubmit"
    ></RejectQuestionnaireReviewDialog>
    <PassQuestionnaireReviewDialog
      ref="PassQuestionnaireReviewDialogRef"
      @submit="handlePassSubmit"
    ></PassQuestionnaireReviewDialog>
  </div>
</template>

<script>
import workFlowCommon from "@/uilt/workFlowCommon";
import { ApproveStateOption } from "./enum";
import PassQuestionnaireReviewDialog from "./components/PassQuestionnaireReviewDialog.vue";
import RejectQuestionnaireReviewDialog from "./components/RejectQuestionnaireReviewDialog.vue";

export default {
  components: {
    PassQuestionnaireReviewDialog,
    RejectQuestionnaireReviewDialog,
  },
  data() {
    return {
      ApproveStateOption,
      showMore: false,
      tableHeight: window.innerHeight - 310,
      contentMainHeight: window.innerHeight - 210,
      fullscreenLoading: false,
      currentStaffGuid: null,
      sendTenantList: [],
      organisationList: [],
      processNameList: [
        { label: "全部", value: null },
        { label: "新增问卷模版申请", value: "00042" },
        { label: "变更问卷模版申请", value: "00043" },
      ],
      optionPlat: [
        { label: "全部", value: null },
        { label: "平台", value: "Y" },
        { label: "药企", value: "N" },
      ],
      page: {
        listType: "0",
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: "",
        organisationGuid: "",
        surveyTitle: "",
        isShowPlatformTemplate: null,
        approveState: "",
        staffName: "",
      },
      tableLoading: false,
      tableData: [],
      /** 当前操作项 */
      currItem: "",
    };
  },
  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.currentStaffGuid = userinfo.staffGuid;
    this.getList(1);
    this.getTenantList();
  },
  activated() {
    this.getList();
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 360;
        this.contentMainHeight = window.innerHeight - 260;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 310;
        this.contentMainHeight = window.innerHeight - 210;
        return;
      }
    },
  },
  methods: {
    toEdit(detail) {
      let query = {
        guid: detail.guid,
        type: 1,
        approveVO: detail.approveVO ? JSON.stringify(detail.approveVO) : '',
        from: 'questionnaireReview',
      };
      let path = "/questionnaireAdd";
      this.$router.push({
        path,
        query,
      });
    },
    toResubmit(detail) {
      let query = {
        guid: detail.guid,
        type: 3,
        approveVO: detail.approveVO ? JSON.stringify(detail.approveVO) : '',
        from: 'questionnaireReview',
      };
      let path = "/questionnaireAdd";
      this.$router.push({
        path,
        query,
      });
    },
    async toRevoke(row) {
      let confirm = false;
      try {
        // 等待用户确认
        confirm = await this.$confirm(messageConfig.FLOW_IS_CANCEL, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
      } catch (error) {
        // 用户点击取消
        this.$message({
          type: "info",
          message: "已取消操作！",
        });
      }
      console.log("confirm", confirm);
      if (!confirm) {
        return;
      }
      // 用户确认后执行撤销逻辑
      const query = {
        guid: row.approveVO.approveGuid,
        flowType: row.approveVO.flowType,
        approveStaffGuid: row.approveVO.staffGuid,
      };
      this.tableLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`,
        query
      );
      this.tableLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.$message.success(messageConfig.FLOW_CANCEL);
      this.getList();
    },
    filterFlow() {
      this.getList();
    },
    getListBtnState(btnType, row) {
      let approveVO = row.approveVO || {};
      return workFlowCommon.getListBtnState(
        btnType,
        approveVO.approveState,
        approveVO.staffGuid,
        approveVO.approveStaffGuids,
        this.currentStaffGuid,
        row.bizApproveState
      );
    },
    getStateShow(approvalState) {
      return workFlowCommon.getStateClass(approvalState);
    },
    getRuleList(arr){
      let list=[]
      if(arr.length>0){
        list=arr.slice(0,3)
      }
      return list
    },
    async getTenantList() {
      let self = this;
      let query = {
        enterpriseCates: [...this.$getValueListByKey("上游客户分类"), "9901"],
        pageIndex: 1,
        pageSize: -1,
      };
      const { data } = await self.api.postJson(
        `/${serverConfig.msCustomerService}/tenant/data/get`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      self.sendTenantList = data.data.records || [];
    },
    async getOrganisationList(v) {
      this.page.organisationGuid = "";
      if (!v) return;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
      };

      const { data } = await this.api.postJson(
        `/${serverConfig.msPersonnelService}/organisation/data/get`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.organisationList = data.data.records || [];
    },
    handleChangeCompany(v) {
      this.page.organisationGuid = "";
      this.getOrganisationList(v);
    },
    async getList(pageIndex) {
      if (pageIndex) {
        this.page.pageIndex = pageIndex;
      }
      let userInfo = JSON.parse(localStorage.userInfo);
      let query = {
        ...this.page,
        serviceTenantGuid: localStorage.guid,
        staffGuid: userInfo.staffGuid,
        startTime: "",
        endTime: "",
      };
      const [startTime, endTime] = query.submitTime || [];
      if (startTime && endTime) {
        query.startTime = this.$moment(startTime).format("YYYY-MM-DD HH:mm:ss");
        query.endTime = this.$moment(endTime).format("YYYY-MM-DD 23:59:59");
      }
      delete query.submitTime;
      this.tableLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/survey/tenant/approve-list`,
        query
      );
      this.tableLoading = false;

      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.tableData = data.data.records || [];
      this.page.totalRows = data.data.totalRows || 0;
    },
    emptySearch() {
      this.page = {
        listType: "0",
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: "",
        organisationGuid: "",
        surveyTitle: "",
        isShowPlatformTemplate: null,
        approveState: "",
        staffName: "",
      };
      this.getList(1);
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.getList();
    },
    passDialogClick(row) {
      this.currItem = row;
      this.$refs.PassQuestionnaireReviewDialogRef.open();
    },
    rejectDialogClick(row) {
      this.currItem = row;
      this.$refs.RejectQuestionnaireReviewDialogRef.open();
    },
    async handlePassSubmit(val) {
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        guid: this.currItem.approveVO.approveGuid,
        flowType: this.currItem.approveVO.flowType,
        approveSuggest: val,
        approveStaffGuid: userinfo.staffGuid,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`,
        query
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.$refs.PassQuestionnaireReviewDialogRef.close();
      this.$message.success(messageConfig.FLOW_PASS);
      this.getList();
    },
    async handleRejectSubmit(val) {
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        guid: this.currItem.approveVO.approveGuid,
        flowType: this.currItem.approveVO.flowType,
        approveSuggest: val,
        approveStaffGuid: userinfo.staffGuid,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`,
        query
      );
      this.fullscreenLoading = false;
      this.$refs.RejectQuestionnaireReviewDialogRef.close();
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.$message.success(messageConfig.FLOW_REJECT);
      this.getList();
    },
    toDetail(row) {
      let query = {
        guid: row.guid,
        type: 2,
        approveVO: row.approveVO ? JSON.stringify(row.approveVO) : '',
        from: 'questionnaireReview',
      };
      this.$router.push({
        path: "/questionnaireAdd",
        query: query,
      });
    },
  },
};
</script>

<style scoped>
.tab-wrap {
  background: #fff;
  :deep(.el-tabs__nav) {
    margin-left: 10px;
  }
}

.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.ipt-sty {
  flex: 1;
}

a.txt-color + a.txt-color::before {
  content: "|";
  display: inline-block;
}
.flow-dialog {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.flow-dialog .flow-item {
  width: 90%;
  font-weight: bold;
  width: 200px;
  padding: 25px 0;
  text-align: center;
  border: 1px solid rgba(235, 235, 235, 1);
  border-radius: 4px;
  cursor: pointer;
}
.flow-dialog .flow-item:hover {
  color: #fff;
  background: #4fa1a4;
}
.flow-item-active {
  color: #fff;
  background: #4fa1a4;
}
.flow-dialog-title {
  position: relative;
  text-align: left;
  margin-top: 0;
}
.flow-dialog-title .flow-dialog-line {
  position: absolute;
  top: -3px;
  display: inline-block;
  width: 4px;
  height: 24px;
  background: #4fa1a4;
}
.flow-dialog-title .flow-dialog-txt {
  display: inline-block;
  padding-left: 15px;
}
.search-area-div {
  width: 90px;
  text-align: right;
}
</style>
